import ExpenseDetail from "./ExpenseDetail";

export default ExpenseDetail;
